if (!customElements.get('product-3d-modal')) {
  customElements.define(
    'product-3d-modal',
    class Product3DModal extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('.product__3d-button');
        this.dialog = this.querySelector('.product-3d-modal');
        this.closeButton = this.querySelector('.product-3d-modal__close');
        this.overlay = this.querySelector('.product-3d-modal__overlay');
        this.productModel = this.querySelector('product-model');

        this._onKeyDown = this.onKeyDown.bind(this);

        this.button?.addEventListener('click', this.open.bind(this));
        this.closeButton?.addEventListener('click', this.close.bind(this));
        this.overlay?.addEventListener('click', this.close.bind(this));
        document.addEventListener('keydown', this._onKeyDown);
      }

      disconnectedCallback() {
        document.removeEventListener('keydown', this._onKeyDown);
      }

      onKeyDown(event) {
        if (event.key === 'Escape' && !this.dialog.hasAttribute('hidden')) {
          this.close();
        }
      }

      open() {
        if (this._isIOS()) {
          this._openIOSQuickLook();
        } else if (this._isAndroid()) {
          this._openAndroidAR();
        } else {
          this._openModal();
        }
      }

      // ─── iOS ────────────────────────────────────────────────────────────────
      // Quick Look natif : crée un lien <a rel="ar"> et le clique programmatiquement.
      // Ne nécessite pas model-viewer ni le chargement du modèle — iOS gère tout.
      _openIOSQuickLook() {
        const src = this._getModelSrc();
        if (!src) { this._openModal(); return; }

        const a = document.createElement('a');
        a.rel = 'ar';
        a.href = src;
        a.appendChild(document.createElement('img'));
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      }

      // ─── Android ────────────────────────────────────────────────────────────
      // TODO : déclencher Scene Viewer via intent URL directement (prochaine itération).
      // Pour l'instant : modal de fallback.
      _openAndroidAR() {
        this._openModal();
      }

      // ─── Desktop / fallback ─────────────────────────────────────────────────
      // Charge le model-viewer dans le modal et l'affiche.
      // Bypass setupModelViewerUI pour éviter que Shopify.ModelViewerUI route
      // les interactions AR vers ShopifyXR (qui requiert ProductJSON non disponible
      // pour les modèles issus de metafields).
      _openModal() {
        if (this.productModel) {
          this.productModel.setupModelViewerUI = () => {};
        }
        this.productModel?.loadContent(false);
        customElements
          .whenDefined('model-viewer')
          .then(() => this.showModal())
          .catch(() => this.showModal());
      }

      // ─── Helpers ────────────────────────────────────────────────────────────
      _getModelSrc() {
        return this.productModel
          ?.querySelector('template')
          ?.content.querySelector('model-viewer')
          ?.getAttribute('src') || null;
      }

      _isIOS() {
        return (
          /iPad|iPhone|iPod/.test(navigator.userAgent) ||
          // iPads récents se présentent comme MacIntel avec touch
          (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)
        );
      }

      _isAndroid() {
        return /Android/i.test(navigator.userAgent);
      }

      showModal() {
        this.dialog.removeAttribute('hidden');
        this.button.setAttribute('aria-expanded', 'true');
        document.body.style.overflow = 'hidden';
        this.closeButton?.focus();
      }

      close() {
        this.dialog.setAttribute('hidden', '');
        this.button.setAttribute('aria-expanded', 'false');
        document.body.style.overflow = '';
        this.button?.focus();
      }
    }
  );
}
